import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gatewayFormValidator,
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../utils/gatewayFormValidator";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import QRCodeCard from "../../../../utils/QrCodeCard";
import {
  updateDepositAmount,
  createDeposit,
  getOneGateway,
} from "../../../../redux/user/actions";
import { APP_CONST } from "../../../../config/const";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { Container } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import CopyToClipboard from "react-copy-to-clipboard";

import { AiFillCopy } from "react-icons/ai";
import DisplayValues from "../../../components/gateways/DisplayValues";

const DepositGateway = () => {
  const [selectedGateway, setSelectedGateway] = useState(null);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser = user?.mstruserid === process.env.REACT_APP_DEMO_USER_ID;
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { gateway } = useParams();
  const isBank = gateway === "bank_transfer";
  const showQrImg = selectedGateway?.qrCode !== null;
  const [isCreatingDeposit, setIsCreatingDeposit] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    dispatch(getActiveBankDetails());
    if (gateway !== "bank_transfer") {
      getOneGtwFromServer(gateway);
    }
  }, [gateway]);

  // Get one gtw from server
  const getOneGtwFromServer = async (gtw) => {
    const response = await getOneGateway(gtw);
    if (response) {
      setSelectedGateway(response?.data?.data?.data);
    }
  };
  // console.log("selectedGateway", selectedGateway);
  const validateData = (dataToValidate) => {
    const amountValidation = [];

    if (selectedGateway?.depositSettings?.min) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${selectedGateway?.depositSettings?.min}`,
      });
    }

    if (selectedGateway?.depositSettings?.max) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${selectedGateway?.depositSettings?.max}`,
      });
    }
    let fields = selectedGateway.fields;
    let validations = gatewayFormValidatorWithCustomErrors({
      fields,
      dataToValidate,
      cstmValidation: { amount: amountValidation },
    });
    setErrors(validations);
    return validations;
  };
  const validateBankFormData = (data) => {
    const { amount, utrNo, txnImage } = data;
    let errorVar = {};
    if (!amount) {
      errorVar.amount = "Amount is required";
    }

    if (!txnImage) {
      errorVar.txnImage = "Txn image is required";
    } else if (txnImage && txnImage?.size > 2000000) {
      errorVar.txnImage = "Image size must be less than 2MB";
    }
    setErrors(errorVar);
    return errorVar;
  };

  const handleChange = (e, type = "non-file", fieldType = null) => {
    let name = e.target.name;
    let value = type === "file" ? e.target.files?.[0] : e.target.value;
    let data = { ...formData, [name]: value };
    if (isBank) {
      validateBankFormData(data);
    } else {
      validateData(data);
    }

    setFormData(data);
  };

  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    selectedGateway.fields.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isBank) {
      if (Object.values(validateData({ ...formData })).length == 0) {
        setIsCreatingDeposit(true);
        if (
          selectedGateway.fields.some(
            (f) => f?.accessor === "gateway" && f?.required === true
          )
        ) {
          formData["gateway"] = selectedGateway?.code;
        }
        if (selectedGateway?.slug && selectedGateway?.slug !== null) {
          formData.slug = selectedGateway?.slug;
        }

        const updatedForm = getIfDefaultValue({ data: formData });

        const finalData =
          selectedGateway?.url.indexOf("dynamicmanual") > -1
            ? {
                amount: updatedForm?.amount,
                slug: updatedForm?.slug,
                dynamicFields: updatedForm,
              }
            : updatedForm;

        const response = await updateDepositAmount({
          data: finalData,
          url: selectedGateway?.url,
          isMultiPart: selectedGateway?.fields.some(
            (f) => f?.type === "file" || f?.type === "image"
          ),
        });
        setIsCreatingDeposit(false);
        handleSubmitResponse(response);
        formRef.current?.reset();
        setFormData({});
      }
    } else {
      if (Object.values(validateBankFormData(formData)).length === 0) {
        setIsCreatingDeposit(true);
        createDeposit({ ...formData, utrNo: null })
          .then((res) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, res.data.data.message);
          })
          .catch((err) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
          });
      }
    }
  };

  const handleSubmitResponse = (value) => {
    if (value) {
      if (
        selectedGateway?.url.indexOf("dynamicmanual") > -1 &&
        value?.data?.data
      ) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      if (selectedGateway.type === "manual") {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, value.data.data.message);
      } else if (value?.data?.data?.data && "payUrl" in value?.data.data.data) {
        window.location.href = value?.data?.data?.data?.payUrl;
      } else if (selectedGateway.code === "alphapo") {
        window.location.href = value?.data?.data?.data?.url;
      }
    }
  };

  const renderFields = (field) => {
    switch (field.type) {
      case "file":
      case "image":
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"file"}
              placeholder={field.label}
              name={field.accessor}
              onChange={(e) => handleChange(e, "file")}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span class="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      default:
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName "
          >
            <Form.Control
              type={field.type}
              placeholder={field.label}
              name={field.accessor}
              value={
                !Boolean(formData?.[field?.accessor]) &&
                formData?.[field?.accessor] !== "" &&
                field?.value
                  ? field?.value
                  : formData?.[field?.accessor]
              }
              onChange={(e) => handleChange(e, "non-file", field?.type)}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span class="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
    }
  };

  const renderBankTransferForm = () => {
    return (
      <Form className="gatewayForm" ref={formRef}>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Enter amount"}
            name={"amount"}
            value={formData?.amount || ""}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["amount"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["amount"]}
          </Form.Control.Feedback>
        </Form.Group>

        {/* <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Enter UTR no"}
            name={"utrNo"}
            onChange={(e) => handleChange(e)}
            isInvalid={!!errors["utrNo"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["utrNo"]}
          </Form.Control.Feedback>
        </Form.Group> */}

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"file"}
            placeholder={"Select file"}
            name={"txnImage"}
            onChange={(e) => handleChange(e, "file")}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["txnImage"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["txnImage"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Button onClick={handleSubmit} disabled={isCreatingDeposit}>
          {" "}
          {isCreatingDeposit ? "Submitting" : "Submit"}
        </Button>
      </Form>
    );
  };
  return (
    <>
      {isDemoUser && <Navigate to="/" />}
      <HeaderAfterLogin />
      <main className="main mt-5">
        {!isBank ? (
          <Container>
            <div className="heading">{selectedGateway?.name}</div>
            <DisplayValues
              displayItems={selectedGateway?.depositDisplayFields}
            />
            {selectedGateway?.type === "manual" &&
              selectedGateway?.url !== "/deposit/pay/dynamicmanual" && (
                <>
                  <div className="valuesDeposit">
                    {/* <h3>Wallet : {selectedGateway?.value}</h3> */}
                    <h3>UPI : {selectedGateway?.displayValue}</h3>

                    <div className="copyValue">
                      <CopyToClipboard
                        text={selectedGateway?.displayValue}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>
                      {/* <CopyToClipboard
                      text={selectedGateway?.value?.slice(index1, index2)}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    /> */}
                      <div>Click to copy code</div>
                    </div>
                  </div>
                  {(selectedGateway?.showQr === true && (
                    <div className="d-flex">
                      {showQrImg ? (
                        <div className=" mx-auto  w-full max-w-[12rem]  relative">
                          <div className="ml-4 ">
                            <div className="bg-zinc-50 rounded-lg p-3 qrSize">
                              <img src={selectedGateway?.qrCode} />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <QRCodeCard text={selectedGateway?.value} />
                      )}
                    </div>
                  )) ||
                    null}
                </>
              )}
            <Form className="gatewayForm" ref={formRef}>
              {selectedGateway?.fields?.map((f, i) => {
                return renderFields(f);
              })}
              <span class="focus-border">
                <i></i>
              </span>
              <Button onClick={handleSubmit} disabled={isCreatingDeposit}>
                {" "}
                {isCreatingDeposit ? "Submitting" : "Submit"}
              </Button>
            </Form>
          </Container>
        ) : (
          <Container>
            <div className="heading">{"Bank Transfer"}</div>
            {bankDetails && (
              <div style={{ padding: "15px 0 0 5px" }}>
                <p>
                  Account name : {bankDetails?.acc_name}{" "}
                  <CopyToClipboard
                    text={bankDetails?.acc_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  >
                    <AiFillCopy />
                  </CopyToClipboard>
                </p>
                <p>
                  Account number : {bankDetails?.acc_no}{" "}
                  <CopyToClipboard
                    text={bankDetails?.acc_no}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  >
                    <AiFillCopy />
                  </CopyToClipboard>
                </p>
                <p>
                  IFSC code : {bankDetails?.ifsc_code}{" "}
                  <CopyToClipboard
                    text={bankDetails?.ifsc_code}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  >
                    <AiFillCopy />
                  </CopyToClipboard>
                </p>
                <p>
                  Bank name : {bankDetails?.bank_name}{" "}
                  <CopyToClipboard
                    text={bankDetails?.bank_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  >
                    <AiFillCopy />
                  </CopyToClipboard>
                </p>
              </div>
            )}
            {bankDetails && renderBankTransferForm()}
          </Container>
        )}
      </main>
      <Footer />
    </>
  );
};
export default DepositGateway;
